import React, { useEffect, useState } from "react";
import {
    withGoogleMap,
    withScriptjs,
    GoogleMap,
    Marker as GoogleMarker,
} from "react-google-maps";
const { InfoBox } = require("react-google-maps/lib/components/addons/InfoBox");

function Marker({
    position,
    displayInfoBox,
    onInfoBoxClose,
    onMarkerClick,
    clinic,
}) {
    const [showInfoBox, setShowInfoBox] = useState(displayInfoBox);

    useEffect(() => {
        setShowInfoBox(displayInfoBox);
    }, [displayInfoBox]);

    return (
        <GoogleMarker
            onClick={() => {
                if (onMarkerClick) onMarkerClick();
                else setShowInfoBox(true);
            }}
            position={{ lat: position.lat, lng: position.lng }}
        >
            {showInfoBox && (
                <InfoBox
                    onCloseClick={() => {
                        setShowInfoBox(false);
                        if (onInfoBoxClose) onInfoBoxClose();
                    }}
                    options={{ closeBoxURL: ``, enableEventPropagation: true }}
                >
                    <div
                        style={{
                            backgroundColor: `white`,
                            padding: `12px`,
                            maxWidth: 200,
                            borderRadius: `15px`,
                        }}
                    >
                        <div className="flex">
                            <div className="d-flex flex-row">
                                <div
                                    style={{
                                        fontSize: `14px`,
                                        fontColor: `#08233B`,
                                    }}
                                >
                                    <b>{clinic.name}</b>
                                </div>
                                <div>
                                    <button type="button" onClick={() => {
                                        window.open(`https://www.google.com/maps/search/?api=1&query=${clinic.latitude},${clinic.longitude}`, '_blank');
                                    }} className=" ml-2 decoration-none btn btn-sm btn-light btn-outline">
                                        <ion-icon name="map-outline" className="color-primary"></ion-icon>
                                    </button>
                                </div>
                            </div>
                            <div
                                style={{
                                    fontSize: `10px`,
                                    fontColor: `#08233B`,
                                }}
                            >
                                {clinic.address}
                            </div>
                            <div>
                                {clinic.is_open ? (
                                    <div>
                                        <span class="badge badge-success">
                                            Open
                                        </span>{" "}
                                        - closes at {clinic.today_close}
                                    </div>
                                ) : (
                                    <span class="badge badge-danger">
                                        Closed
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </InfoBox>
            )}
        </GoogleMarker>
    );
}

export default Marker;
